'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
var Text_module = require('../styles/Text.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/** Helper function */
const convertSizeAdaptiveToClassNames = (size) => {
    if (reactUtils.isUndefined(size))
        return [];
    const breakpoints = Object.keys(size);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? size[breakpoint]
        : `${breakpoint}-${size[breakpoint]}`;
    return breakpoints.map((breakpoint) => `size-${createName(breakpoint)}`);
};
/**
 * @description The Text component is used for single line or multiline text. The component renders a div element by default
 *
 * @component
 * @example
 * ```jsx
 * <Text as="div" size="xl" strong>Text</Text>
 * ```
 */
const Text = React__namespace.forwardRef((props, ref) => {
    const { as, size, strong, uppercase, capitalize, lowercase, truncate, nowrap, lineThrough, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Text_module.default);
    const sizeAdaptive = React__namespace.useMemo(() => (reactUtils.isNumber(size) ? { mobile: size } : size), [size]);
    const classNames = cx(className, {
        strong,
        uppercase,
        capitalize,
        lowercase,
        truncate,
        nowrap,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'line-through': lineThrough,
    }, ...convertSizeAdaptiveToClassNames(sizeAdaptive));
    return React__namespace.createElement(as, {
        ref,
        className: classNames,
        ...restProps,
    }, children);
});
Text.defaultProps = {
    size: sizes.FONT_SIZES.S14,
    as: 'div',
};
Text.displayName = 'Text';

exports.Text = Text;
//# sourceMappingURL=Text.js.map
